module.exports = __webpack_public_path__ + "static/media/dragdrop-icon.2ff7dec0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/dragdrop-icon.svg
// module id = 820
// module chunks = 0